import { EMPTY_STRING } from '~/utils/constants/common';
import { ProductDesignationEnum } from '~/utils/enum/common';
import { IFormSliptOrder, IOrderItemJobSplit, IOrderSplit } from '~/utils/interface/order';

export const convertOrderToKanban = (data: IOrderSplit) => {
  const jobItemsColumns = [];

  let jobsData = data?.jobs && data?.jobs?.length > 0 ? data?.jobs : [{ id: '', title: 'Part 1', jobItems: [] }];

  const jobColumns = jobsData.map((job, indexJob) => {
    const orderItemIds = job.jobItems?.map((ji: IOrderItemJobSplit) => ji.id) ?? [];

    const items =
      job.jobItems?.map((ji: IOrderItemJobSplit) => ({
        idDetail: ji.id,
        title: ji.name,
        variantName: ji.variantName,
        indexJob,
        position: ji.position,
        orderItemIds: orderItemIds,
      })) ?? [];

    return {
      id: String(job.id),
      name: 'Part 1',
      items,
    };
  });

  jobItemsColumns.push(...jobColumns);

  const assignedItemIds = new Set(
    jobsData.flatMap((job) => job.jobItems?.map((ji: IOrderItemJobSplit) => ji.id) ?? [])
  );

  const unassignedItems =
    data.orderItems
      ?.filter((item) => !assignedItemIds.has(item.id))
      .map((item) => ({
        idDetail: item.id,
        title: item.name,
        variantName: item.variantName,
        indexJob: -1,
        position: item.position,
      })) ?? [];

  unassignedItems.length > 0 &&
    jobItemsColumns.push({
      id: ProductDesignationEnum.UNASSIGNED,
      name: 'Unassigned',
      items: unassignedItems,
    });

  const jobSettings = [];

  jobsData?.forEach((job: any) => {
    jobSettings.push({
      isDefault: true,
      id: job.id ?? EMPTY_STRING,
      title: job.title ?? EMPTY_STRING,
      type: job?.type ? job?.type : undefined,
      foremanId: job?.foreman ? job?.foreman?.id : undefined,
      crewIds: job?.crews && job?.crews?.length > 0 ? job?.crews?.map((item: any) => item.id) : [],
      loaderId: job?.loader && job?.loader?.length > 0 ? job?.loader?.map((item: any) => item.id) : [],
      truckId: job?.truck ? job?.truck?.id : undefined,
      trailerId: job?.trailer ? job?.trailer?.id : undefined,
      driverId: job?.driver ? job?.driver?.id : undefined,
      orderItemIds: job.jobItems?.map((ji: IOrderItemJobSplit) => ji.id) ?? [],
    });
  });

  data?.orderItems?.length > 0 &&
    jobSettings.push({
      isDefault: true,
      id: ProductDesignationEnum.UNASSIGNED,
      title: 'Unassigned',
      type: 'unassigned',
    });

  return {
    jobItems: jobItemsColumns,
    jobs: jobSettings,
  };
};

export const convertColumnsToOrders = (data: IFormSliptOrder) => {
  const { jobItems, jobs } = data;

  if (!jobItems || !jobs) return [];

  const updateJobs = jobs.filter((col) => col.id !== ProductDesignationEnum.UNASSIGNED);

  return jobItems
    .filter((col) => col.id !== ProductDesignationEnum.UNASSIGNED)
    .map((col, index) => {
      const job = updateJobs[index];

      return {
        id: job?.id ? job?.id : undefined,
        title: job?.title ? job?.title : undefined,
        type: job?.type ? job?.type : undefined,
        crewIds: job?.crewIds ? job?.crewIds : [],
        foremanId: job?.foremanId ? job?.foremanId : undefined,
        loaderId: job?.loaderId ? job?.loaderId : [],
        truckId: job?.truckId ? job?.truckId : undefined,
        trailerId: job?.trailerId ? job?.trailerId : undefined,
        driverId: job?.driverId ? job?.driverId : undefined,
        orderItemIds: col.items.map((item) => item.idDetail).filter((id): id is string => id !== undefined) as string[],
      };
    });
};
